import { useEffect, useState } from 'react'
import { Link, useHistory, useRouteMatch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import PageHeader from 'components/PageHeader'
import Pagination from 'components/pagination/Pagination'
import {
  deleteDocument,
  fetchDocuments,
  fetchDocumentsCount,
  reset,
  setPage,
  setSize,
} from 'features/document/documentListSlice'
import DocumentListItem from 'features/document/DocumentListItem'
import Table from 'components/table/Table'
import PageSize from 'components/pagination/PageSize'
import { useConfirm } from 'features/dialog/Confirm'
import { fail, success } from 'features/toast/Toast'

const DocumentList = () => {
  const match = useRouteMatch()
  const history = useHistory()
  const dispatch = useDispatch()
  const { documents, page, total, size, documentsCount, loading, error } =
    useSelector(state => state.document.documentList)
  const [DeleteConfirm, showDeleteConfirm] = useConfirm()
  const [deleteTarget, setDeleteTarget] = useState(null)

  useEffect(() => () => dispatch(reset()), [dispatch])
  useEffect(() => {
    dispatch(fetchDocumentsCount())
  }, [dispatch])
  useEffect(() => {
    dispatch(fetchDocuments())
  }, [dispatch, size, page])

  const handlePageChange = v => dispatch(setPage(v))
  const handleSizeChange = v => dispatch(setSize(v))

  const handleDeleteClick = target => {
    setDeleteTarget(target)
    showDeleteConfirm()
  }

  const handleDeleteConfirm = async ({ isConfirmed }) => {
    if (!isConfirmed) return
    const { error: deleteError } = await dispatch(
      deleteDocument(deleteTarget.id)
    )
    if (deleteError) {
      fail(
        '일시적인 오류로 서류를 삭제할 수 없습니다. 잠시 후 다시 시도하세요.'
      )
      return
    }
    success('심사서류가 삭제되었습니다.')
    dispatch(fetchDocuments())
    dispatch(fetchDocumentsCount())
  }

  return (
    <>
      <DeleteConfirm title="서류파일 삭제" onClose={handleDeleteConfirm}>
        선택한 파일을 삭제하시겠습니까?
        <br />
        삭제 후 복구할 수 없습니다.
      </DeleteConfirm>
      <div className="accountmanage_wrap">
        <div className="dsp_tit">
          <PageHeader pageTitle="심사서류 관리" />
        </div>
        <div className="ad_managebox">
          <div className="managebox_tit">
            <strong className="tit_box">
              총 심사서류<span className="fc_emph"> {documentsCount}</span>
            </strong>
            <div className="f_left">
              <div className="single_wrap">
                <Link to={`${match.url}/add`} className="btn_gm gm_bl">
                  <span className="inner_g">
                    <span className="img_comm ico_add" />
                    심사서류 등록하기
                  </span>
                </Link>
              </div>
            </div>
          </div>
          <div className="tblg2_wrap">
            <Table
              className="tbl_g2 doc_tbl"
              caption="심사서류 관리 표"
              emptyMessage={
                <>
                  등록한 서류가 없습니다.
                  <br />
                  <Link
                    to={`${match.url}/add`}
                    className="link_txt"
                    style={{ display: 'inline' }}>
                    심사서류 등록하기
                  </Link>
                  를 클릭하여 심사에 필요한 서류를 등록하세요.
                </>
              }
              error={error}
              loading={loading}>
              <Table.Head>
                <Table.Column title="비즈채널" />
                <Table.Column title="구분" width={170} />
                <Table.Column title="서류 ID" width={190} />
                <Table.Column title="심사서류" width={320} />
                <Table.Column title="업데이트 일시" width={176} />
              </Table.Head>
              <Table.Body>
                {documents.map(document => (
                  <DocumentListItem
                    key={document.channelId}
                    id={document.channelId}
                    document={document}
                    onClick={() =>
                      history.push(`${match.url}/add/${document.channelId}`)
                    }
                    onDeleteClick={handleDeleteClick}
                  />
                ))}
              </Table.Body>
            </Table>
          </div>
          {total > 0 && (
            <div className="paging_wrap">
              <div className="inner_paging">
                <Pagination
                  total={total}
                  current={page}
                  size={size}
                  onChange={handlePageChange}
                />
                <PageSize
                  onSizeChange={s => {
                    handlePageChange(0)
                    handleSizeChange(s)
                  }}
                  size={size}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default DocumentList
